import { StyledUnderline } from '@components/Underline/styled';
import styled from 'styled-components';

export const StyledText = styled.p`
  font-size: var(--text-size);
  line-height: 1.3;
  font-weight: 400;
  letter-spacing: .2px;

  position: relative;
  z-index: 1;

  ${StyledUnderline} {
    font-weight: 600;
  }
`;